import React from "react";
import { getBackgroundColor } from "../../../utils/FlightStatusUtils";
import TitleBar from "./TitleBar";
import AirportBlock from "./AirportBlock";
import ScheduleBlock from "./ScheduleBlock";
import RouteBar from "./RouteBar";
import { transformToHtml } from "../../../utils/CommonUtils";

export default function FlightStatusTiming({ statusCardData, logEvent }) {
  if (!statusCardData) return null;

  return (
    <div className="fsd-timing br8 whiteBg">
      {statusCardData.titleBar && <TitleBar data={statusCardData.titleBar} />}

      <div className="fsd-card-body whiteBg padding24 br8">
        <div className="fsd-main-row makeFlex gap24 appendBottom24">
          {statusCardData.departureInfo && (
            <AirportBlock data={statusCardData.departureInfo} />
          )}
          {statusCardData.arrivalInfo && (
            <AirportBlock data={statusCardData.arrivalInfo} isArrival />
          )}
        </div>

        {statusCardData.incomingFlightStatus && (
          <div
            className="fontSize16 padding10 br8 appendBottom24"
            style={getBackgroundColor(statusCardData.incomingFlightStatus.bgColors)}
          >
            {transformToHtml(statusCardData.incomingFlightStatus.text)}
          </div>
        )}

        <div className="fsd-second-row gap16 makeFlex spaceBetween alignCenter">
          {statusCardData.departureInfo && (
            <ScheduleBlock
              scheduledInfo={statusCardData.departureInfo.scheduledInfo}
              actualOrExpectedInfo={statusCardData.departureInfo.actualOrExpectedInfo}
            />
          )}

          {statusCardData.routeBar && <RouteBar data={statusCardData.routeBar} />}

          {statusCardData.arrivalInfo && (
            <ScheduleBlock
              scheduledInfo={statusCardData.arrivalInfo.scheduledInfo}
              actualOrExpectedInfo={statusCardData.arrivalInfo.actualOrExpectedInfo}
              isArrival
            />
          )}
        </div>
      </div>
    </div>
  );
}
